var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "info",
    d: "M23,0A23,23,0,1,1,0,23,23,23,0,0,1,23,0Zm0,4.182A18.818,18.818,0,1,0,41.818,23,18.818,18.818,0,0,0,23,4.182Zm0,16.727a2.091,2.091,0,0,1,2.076,1.846l.015.245v8.364a2.091,2.091,0,0,1-4.167.245l-.015-.245V23A2.091,2.091,0,0,1,23,20.909Zm.021-8.364a2.091,2.091,0,0,1,.245,4.167L23,16.727a2.091,2.091,0,0,1-.245-4.167Z",
    fill: "#4a4a4a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.11f2ccd22521545338b8dae3e9af453a.svg";
export { ForwardRef as ReactComponent };